const ModuleLiveTimer = {
  state: {
    timers: {}
  },
  mutations: {
    settimers (state, { dealId, time }) {
      // state.timers[dealId] = time
      this._vm.$set(state.timers, dealId, time)
    },
    cleartimer (state, { dealId }) {
      this._vm.$delete(state.timers, dealId)
    }
  }
}

export default ModuleLiveTimer
